export const getPlaceholderAvatar = (email: string) => {
  return `https://api.dicebear.com/8.x/identicon/svg?seed=${email}`;
};
